import CrudRepository from './CrudRepository'
export default class LogoutRepository extends CrudRepository {
  constructor () {
    super('api/users/signout')
  }
}
